import { 
  BarChart3, 
  Database, 
  Activity, 
  Settings, 
  Workflow,
  HelpCircle,
  Home
} from 'lucide-react';

export const navbarLinks = [
  {
    title: "Main",
    links: [
      {
        label: "Overview",
        path: "/dashboard",
        icon: BarChart3
      },
      {
        label: "Migrations",
        path: "/dashboard/migrations",
        icon: Database
      },
      {
        label: "Analytics",
        path: "/dashboard/analytics",
        icon: Activity
      }
    ]
  },
  {
    title: "Configuration",
    links: [
      {
        label: "Settings",
        path: "/dashboard/settings",
        icon: Settings
      },
      {
        label: "Integrations",
        path: "/dashboard/integrations",
        icon: Workflow
      }
    ]
  },
  {
    title: "Support",
    links: [
      {
        label: "Help & Support",
        path: "/dashboard/help",
        icon: HelpCircle
      }
    ]
  }
];